import Immutable from 'seamless-immutable';
import { handleActions } from 'redux-actions';
import { tasks as actionTypes } from '$constants/action-types';
import { updateOrInserAll } from './helper';

const defaultState = Immutable({
  items: []
});

const reducer = {
  [actionTypes.FETCH_ALL_REQUEST](state) {
    return state.set('isFetching', true);
  },

  [actionTypes.FETCH_ALL_FAILURE](state) {
    return state.set('isFetching', false);
  },

  [actionTypes.FETCH_ALL_SUCCESS](state, action) {
    return updateOrInserAll(state, action.result)
                .set('hasMore', action.hasMore)
                .set('isFetching', false);
  },

  CLEAR_TASKS(state) {
    return defaultState;
  }
}

export default handleActions(reducer, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/tasks.js